import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export function jsonActionsSystemDevices (rebootShutdownRestart, id, handleModal, identity, so, { actionWipe, actionReboot, actionShutdown, actionErrorLogs, actionSendCommand }) {
  // Despliegue de boton de acciones de sistema
  const { t } = useTranslation('dashboardDevice')
  const result = []

  if (actionWipe && so?.includes('Android')) {
    result.push({
      label: t('speedDialMenu.item1'),
      icon: 'pi pi-exclamation-triangle',
      command: () => {
        rebootShutdownRestart(
          'wipe',
          t('speedDialMenu.item1'),
          'devices',
          identity
        )
      }
    })
  }

  if (actionReboot) {
    result.push({
      label: t('speedDialMenu.item2'),
      icon: 'pi pi-replay',
      command: () => {
        rebootShutdownRestart('reboot', t('speedDialMenu.item2'), 'devices', identity)
      }
    })
  }

  if (actionShutdown) {
    result.push({
      label: t('speedDialMenu.item3'),
      icon: 'pi pi-power-off',
      command: () => {
        rebootShutdownRestart('shutdown', t('speedDialMenu.item3'), 'devices', identity)
      }
    })
  }

  if (actionErrorLogs) {
    result.push({
      label: t('speedDialMenu.item4'),
      icon: 'pi pi-desktop',
      command: () => {
        handleModal('errorLogs', true)
      }
    })
  }

  return result
}

export function jsonActionsContent (handleModal, so, { actionBackgroundChange, actionContentDownload, actionSendMessage, actionSendCommand, actionModifyScreenBrightness }) {
  // Despliegue de boton de acciones de contenido
  const { t } = useTranslation('dashboardDevice')
  const result = []

  if (actionSendCommand && (so?.includes('Windows') || so?.includes('Ubuntu'))) {
    result.push(
      {
        label: t('speedDialMenu.item5'),
        icon: 'pi pi-code',
        command: () => {
          handleModal('sendCommand', true)
        }
      }
    )
  }

  if (actionModifyScreenBrightness) {
    result.push({
      label: t('speedDialMenu.item6'),
      icon: 'pi pi-sun',
      command: () => {
        handleModal('modifyScreenBrightness', true)
      }
    })
  }

  if (actionBackgroundChange) {
    result.push({
      label: t('speedDialMenu.item7'),
      icon: 'pi pi-window-minimize',
      command: () => {
        handleModal('backgroundChange', true)
      }
    })
  }
  if (actionContentDownload) {
    result.push({
      label: t('speedDialMenu.item8'),
      icon: 'pi pi-upload',
      command: () => {
        handleModal('contentDownload', true)
      }
    })
  }

  if (actionSendMessage) {
    result.push({
      label: t('speedDialMenu.item9'),
      icon: 'pi pi-comment',
      command: () => {
        handleModal('message', true)
      }
    })
  }

  return result
}

export function jsonActionsSecurityDevices (handleModal, data, deleted, so, { actionReports, actionLockDevice, actionActivateDevice, actionDeleteFolders, actionLockScreen, actionMissingDevice }, lockScreenAction, missingDeviceAction) {
  // Despliegue de boton de acciones de contenido
  const result = []
  const { t } = useTranslation('dashboardDevice')

  if (actionReports) {
    result.push({
      label: t('speedDialMenu.item10'),
      icon: 'pi pi-chart-line',
      command: () => {
        handleModal('reports', true)
      }
    })
  }

  if (actionMissingDevice) {
    result.push({
      label: data.missing ? t('speedDialMenu.item11') : t('speedDialMenu.item12'),
      icon: data.missing ? 'pi pi-stop-circle' : 'pi pi-tag',
      command: () => {
        if (data.missing) missingDeviceAction('remove', data)
        else missingDeviceAction('add', data)
      }
    })
  }

  if (actionLockScreen) {
    result.push({
      label: t('speedDialMenu.item13'),
      icon: 'pi pi-tablet',
      command: () => {
        lockScreenAction(data)
      }
    })
  }

  if (actionActivateDevice) {
    result.push({
      label:
        data.motive_lock === 'disabled' ? t('speedDialMenu.item14') : (data.motive_lock === null || data.motive_lock === 'activated' || data.motive_lock === 'unlocked') ? t('speedDialMenu.item15') : '',
      icon:
        data.motive_lock === 'disabled' ? 'pi pi-check-circle' : (data.motive_lock === null || data.motive_lock === 'activated' || data.motive_lock === 'unlocked') ? 'pi pi-times-circle' : '',
      disabled: data.motive_lock === 'locked',
      command: () => {
        if ((data.motive_lock === null || data.motive_lock === 'activated' || data.motive_lock === 'unlocked') && (data.status_lock === false || data.status_lock === null)) {
          deleted('desactivar', data)
        } else {
          deleted('activar', data)
        }
      }
    })
  }
  if (actionLockDevice) {
    result.push({
      label:
        data.motive_lock === 'locked' ? t('speedDialMenu.item16') : (data.motive_lock === null || data.motive_lock === 'unlocked' || data.motive_lock === 'disabled' || data.motive_lock === 'activated') ? t('speedDialMenu.item17') : '',
      icon:
        data.motive_lock === 'locked' ? 'pi pi-lock-open' : (data.motive_lock === null || data.motive_lock === 'unlocked' || data.motive_lock === 'disabled' || data.motive_lock === 'activated') ? 'pi pi-lock' : '',
      command: () => {
        if ((data.motive_lock === null || data.motive_lock === 'unlocked' || data.motive_lock === 'disabled' || data.motive_lock === 'activated')) {
          handleModal('bloquear', true)
        } else {
          handleModal('desbloquear', true)
        }
      }
    })
  }

  if (actionDeleteFolders) {
    result.push(
      {
        label: t('speedDialMenu.item18'),
        icon: 'pi pi-trash',
        command: () => {
          handleModal('deleteFolders', true)
        }
      }
    )
  }

  return result
}

export function jsonGroupPreferences (handleModal, { actionUseTimePreferences, actionDeletePreferences, actionLeasingGroup }) {
  // Despliegue del botón de preferencias en el dashboard de un grupo
  const { t } = useTranslation('dashboardDevice')
  const result = []

  if (actionUseTimePreferences) {
    result.push({
      label: t('speedDialMenu.item19'),
      icon: 'pi pi-clock',
      command: () => {
        handleModal('useTimePreferences', true)
      }
    })
  }

  if (actionDeletePreferences) {
    result.push({
      label: t('speedDialMenu.item20'),
      icon: 'pi pi-eraser',
      command: () => {
        handleModal('deleteGroupPreference', true)
      }
    })
  }

  if (actionLeasingGroup) {
    result.push({
      label: t('speedDialMenu.item21'),
      icon: 'pi pi-money-bill',
      command: () => {
        handleModal('leasingGroup', true)
      }
    })
  }

  return result
}

export function jsonAdditional (handleModal, id, { actionRxartSecure, actionEstablishment, actionHardware }, so, idRxart) {
  // Despliegue de boton de acciones de contenido
  const { t } = useTranslation('dashboardDevice')
  const result = []
  const navigate = useNavigate()

  if (actionRxartSecure && idRxart) {
    result.push(
      {
        label: t('speedDialMenu.item22'),
        icon: 'pi pi-shield',
        command: () => {
          handleModal('RSDevice', true)
        }
      }
    )
  }

  if (actionEstablishment) {
    result.push({
      label: t('speedDialMenu.item23'),
      icon: 'pi pi-building',
      command: () => {
        handleModal('establishment', true)
      }
    })
  }

  if (actionHardware) {
    result.push({
      label: t('speedDialMenu.item24'),
      icon: 'pi pi-server',
      command: () => {
        navigate(`/mdm/hardware/${id}`)
      }
    })
  }

  return result
}

export function jsonInfoDashboard (data) {
  const { t } = useTranslation('dashboardDevice')

  return [
    {
      title: t('info.one'),
      value: data.identity,
      icon: 'fa-solid fa-mobile'
    },
    {
      title: t('info.two'),
      value: data.last_date,
      icon: 'fa-solid fa-clock'
    },
    {
      title: t('info.three'),
      value: data?.so,
      icon:
        data?.so.includes('Android') ? 'fa-brands fa-android' : 'fa-brands fa-windows'
    },
    {
      title: t('info.four'),
      value:
        data.status_lock === null || data.status_lock === false
          ? t('info.five')
          : data.status_lock === 'pending lock'
            ? t('info.six')
            : data.status_lock === 'pending unlock'
              ? t('info.seven')
              : t('info.eight'),
      icon:
        data.status_lock === null || data.status_lock === false
          ? 'fa-sharp fa-solid fa-unlock'
          : 'fa-sharp fa-solid fa-lock'
    }
  ]
}
